export enum Carrier {
  FedEx = "FedEx",
  UPS = "UPS",
  DHL = "DHL",
}
